import type { TPayoutPaymentMethod } from 'api/merchants/balance/types';
import type { TComponent } from 'utils/types/component';

import { columns } from 'components/domains/BalanceTableRedesign/columns';

import type { TBalance } from 'models/Merchant/Balance';

import { TableContent } from '../TableContent';

interface IPayoutsContentProps {
    item: TBalance;
}

export const PayoutsContent: TComponent<IPayoutsContentProps> = ({ item }) => {
    return (
        <TableContent<TPayoutPaymentMethod>
            data={item.payoutMethods}
            columns={columns.payoutsColumns}
            rowKey={(record) => record.formViewName}
        />
    );
};
